import { getHebrewLetters, getEnglishLetters } from '@/custom/classes/my_utils.js'
class FileHelper {
  getErrors (file_name) {
    let pass_array = []
    let hebrew_letters = getHebrewLetters()
    let english_letters = getEnglishLetters()
    let numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    let hyphen = ['-', '_', '.']
    let space = [' ']
    pass_array = pass_array.concat(
      hebrew_letters,
      english_letters,
      numbers,
      hyphen,
      space
    )
    let file_errors = []
    for (let i = 0; i < file_name.length; i++) {
      let char = file_name.charAt(i).toLowerCase()
      if (!pass_array.includes(char) && !file_errors.includes(char)) {
        file_errors.push(char)
      }
    }
    return file_errors
  }

  isAuthorized (file_name) {
    return this.getErrors(file_name).length == 0
  }

  // Classifies which CV variant the company receives for a given file name.
  // super_hide -> generated cv_<env>.pdf, hide -> HR files, regular -> everything else.
  getCvType (file_name) {
    if (!file_name) return 'regular'
    const name = file_name.toLowerCase()
    if (name.match(/^cv_(suitup|piola|rebase|bullrun)\.pdf$/)) return 'super_hide'
    if (name.includes('hr')) return 'hide'
    return 'regular'
  }

  // Send mode -> the CV variant the company should receive. This map MUST stay
  // identical to Cv::FileTypeClassifier on the Rails side (parity asserted by
  // CLS-3 through spec/fixtures/cv/file_names_parity.json). An unknown mode
  // degrades to 'regular' rather than throwing.
  getCvTypeForMode (mode) {
    switch (mode) {
      case 'lite':
        return 'hide'
      case 'super_lite':
        return 'super_hide'
      case 'normal':
      default:
        return 'regular'
    }
  }
}

export default FileHelper
